import Vue from 'vue';

function hasAnyLetter(text) {
  if (!text) {
    return false;
  }
  return text.match(/[a-zA-Z]/g);
}

// eslint-disable-next-line import/prefer-default-export
export const formatarContatoAbertura = (contato) => {
  if (!contato) return '';

  const isTelefone = !hasAnyLetter(contato);
  if (isTelefone) {
    return contato.startsWith('55') ? Vue.filter('phone')(contato.slice(2))
      : Vue.filter('phone')(contato);
  }

  return contato;
};
